module.exports = __webpack_public_path__ + "img/social-network-map@2x.3e7a88b8.webp";